// extracted by mini-css-extract-plugin
export default {"root":"IconShare_root__rIivH"};